export default __webpack_public_path__ + "static/media/snapshot.df67d090.png";